import React, { useEffect, useState } from "react";
import { IoMdArrowDropdown } from "react-icons/io";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import IndianFlag from "../../../assets/icons/India.webp";
import { useAppSelector, checkUserNameExists } from "@hypexone/uicore";
import { SVLS_API_CLIENT } from "../../../App.utils";
import { USERNAME_REGEX } from "../Payments/commonutils";

interface StepOneProps {
  otp: number;
  otpSent: boolean;
  phoneNumber: string;
  agreedToTerms: boolean;
  username: string;
  email: string;
  password: string;
  showPassword: boolean;
  setOtp: Function;
  setPhoneNumber: any;
  onEmailChange: any;
  onPhoneChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onTermsChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onTermsClick?: () => void;
  onUsernameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onPasswordChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  showPasswordClickHandler: Function;
  onUsernameValidityChange: (isValid: boolean) => void;
  campaignCode: string;
  onCampaignCodeChange: (val: string) => void;
}

const StepOne: React.FC<StepOneProps> = ({
  otp,
  otpSent,
  phoneNumber,
  agreedToTerms,
  setPhoneNumber,
  username,
  password,
  showPassword,
  setOtp,
  onEmailChange,
  onPhoneChange,
  email,
  onTermsChange,
  onTermsClick,
  onUsernameChange,
  onPasswordChange,
  showPasswordClickHandler,
  onUsernameValidityChange,
  campaignCode,
  onCampaignCodeChange,
}) => {
  const { langData } = useAppSelector((state) => state.cms);
  const [errorMsg, setErrorMsg] = useState<string>();
    const [otpTimer, setOtpTimer] = useState<number>();
  const [usernameSeleted, setUsernameSelected] = useState<boolean>(false);
  const checkUserExists = async (user: string) => {
    setUsernameSelected(true);
    let valid = true;
    if (user?.length < 4) {
      setErrorMsg("Username must have at least 4 characters");
      return;
    } else if (!USERNAME_REGEX.test(user)) {
      setErrorMsg("Invalid username format");
      return;
    }
    let res = await checkUserNameExists(SVLS_API_CLIENT, user?.toLowerCase());
    if (res === true) {
      setErrorMsg("Username already exists");
      valid = false;
    } else {
      setErrorMsg("");
      valid = true;
    }
    onUsernameValidityChange(valid);
  };
  useEffect(() => {
    if (usernameSeleted) {
      checkUserExists(username);
    }
    else {
      onUsernameValidityChange(false);
    }
  }, [username]);
    useEffect(()=>{
    if(otpSent) {
      handleOtpTimer(60);
    }
  },[otpSent]);
    const handleOtpTimer = (time) => {
    if (time >= 0) {
      setOtpTimer(time);
      setTimeout(() => {
        handleOtpTimer(time - 1);
      }, 1000);
    } else {
      setTimeout(() => {
        setOtpTimer(undefined);
      }, 1000);
    }
  };
    const sendOTP = async () => {
    try {
      
        const response: any = await SVLS_API_CLIENT.post(
          `/account/v2/otp/?mobileNumber=91${phoneNumber}`
        );
        if (response.status === 204) {
          handleOtpTimer(60);
        }
    } catch (err) {
    } 
  };
  return (
    <div className="flex flex-col space-y-2">
      <div className="mt-2">
        <div className="flex gap-2.5 mt-1">
          <div className="w-[80px] text-black p-[2px] h-[44px] flex items-center rounded-md border border-solid border-gray-300 bg-white">
            <img src={IndianFlag} alt="" />
            <div>+91</div>
            <IoMdArrowDropdown />
          </div>
          <input
            type="tel"
            id="phoneNumber"
            className="flex items-center px-3 py-2 w-full h-[44px] bg-white rounded border border-solid border-neutral-200 text-black placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:border-gray-400 focus:ring-gray-400"
            placeholder={langData?.["enter_phone_number_txt"]}
            value={phoneNumber}
            onChange={onPhoneChange}
          />
        </div>
      </div>
    
      <div className="flex gap-2.5 self-start text-black4">
        <input
          type="checkbox"
          id="termsAgreement"
          className="flex shrink-0 w-6 h-6 bg-white rounded-lg border-gray-300"
          checked={agreedToTerms}
          onChange={onTermsChange}
        />
        <label htmlFor="termsAgreement" className="flex-auto my-auto text-black4 text-sm">
          {langData?.["agree_terms_prefix"] ?? "I agree to the "}
          {onTermsClick ? (
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                onTermsClick();
              }}
              className="underline text-black4 bg-transparent border-0 p-0 cursor-pointer font-inherit text-inherit"
            >
              {langData?.["terms_conditions"] ?? "Terms and Conditions"}
            </button>
          ) : (
            (langData?.["terms_conditions"] ?? "Terms and Conditions")
          )}
          .
        </label>
      </div>

      {/* Username */}
      <div>
        {/* <label
          htmlFor="username"
          className="self-start text-black4 font-bold"
        >
          {langData?.["username"]}
        </label> */}
        <input
          type="text"
          id="username"
          className="flex items-center px-3 py-2 w-full h-[44px] bg-white rounded border border-solid border-neutral-200 text-black placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:border-gray-400 focus:ring-gray-400 mt-1"
          placeholder={langData?.["enter_username_txt"]}
          value={username}
          onBlur={(e) => checkUserExists(e.target.value)}
          onChange={onUsernameChange}
        />
        {errorMsg && <div className="text-red-400 text-sm">{errorMsg}</div>}
      </div>

      {/* Password */}
      <div>
        {/* <label
          htmlFor="password"
          className="self-start text-black4 font-bold"
        >
          {langData?.["password"]}
        </label> */}
        <div className="flex items-center px-3 py-2 w-full h-[44px] bg-white rounded border border-solid border-neutral-200 text-black placeholder:text-gray-500 focus-within:outline-none focus-within:ring-2 focus-within:border-gray-400 focus-within:ring-gray-400 mt-1">
          <input
            type={showPassword ? "text" : "password"}
            id="password"
            className="w-full bg-transparent border-none outline-none"
            placeholder={langData?.["enter_password"]}
            value={password}
            onChange={onPasswordChange}
          />
          <div
            className="cursor-pointer text-black4 shrink-0"
            onClick={() => showPasswordClickHandler()}
            role="button"
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            {showPassword ? <FaEye /> : <FaEyeSlash />}
          </div>
        </div>
      </div>
      <div>
        {/* <label htmlFor="campaignCode" className="self-start text-black4 font-bold">
          {langData?.["campaign_code"] || "Campaign Code"}
        </label> */}
        <input
          type="text"
          id="campaignCode"
          className="flex items-center px-3 py-2 w-full h-[44px] bg-white rounded border border-solid border-neutral-200 text-black placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:border-gray-400 focus:ring-gray-400 mt-1"
          placeholder={
            langData?.["enter_campaign_code"] ?? "Enter Campaign Code"
          }
          value={campaignCode}
          onChange={(e) => onCampaignCodeChange(e.target.value)}
        />
        </div>
      
      {otpSent && (
        <div>
          <label htmlFor="otp" className="self-start text-black4 font-bold">
            {langData?.["otp"]} *
          </label>
          <div className="flex gap-2.5 mt-1">
            <input
              type="tel"
              id="otp"
              className="px-3 py-4 mt-3 w-full bg-white rounded-lg border border-solid border-neutral-200 text-black placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:border-gray-400 focus:ring-gray-400"
              placeholder={langData?.["enter_otp_txt"]}
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
          </div>
          <div
            className="text-black4 text-sm mt-1 cursor-pointer underline"
            role="button"
            onClick={() => {
              if (!otpTimer) {
                sendOTP();
              }
            }}
          >
            {otpTimer !== undefined && otpTimer !== null && otpTimer >= 0
              ? `${langData?.["resend_in_txt"]} ${otpTimer} ${langData?.["seconds"]}`
              : `${langData?.["send_otp"]}`}
          </div>
        </div>
      )}
    </div>
  );
};

export default StepOne;
